<select
  name="{{prefix}}[{{name}}]"
  id="{{id}}"
  {{#if testIdPrefix}}data-testid="{{testIdPrefix}}-{{dasherize name}}"{{/if}}
  {{#if required}}required{{/if}}
  {{#if disabled}}disabled{{/if}}
>
  {{#each options}}
    <option
      value="{{get this 'value'}}"
      {{#equal (get this 'value') ../value}}selected{{/equal}}
    >
      {{get this 'name'}}
    </option>
  {{/each}}
</select>
